var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaskGroup284(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 266,
    height: 125,
    viewBox: "0 0 266 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_914",
    "data-name": "Rectangle 914",
    width: 266,
    height: 125,
    transform: "translate(-9896.187 -6918.412)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.025,
    y1: 0.5,
    x2: 1,
    y2: 0.343,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6a0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5f0c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 0.342,
    x2: 0.981,
    y2: 0.08,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7a0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff3b0a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_284",
    "data-name": "Mask Group 284",
    transform: "translate(9896.187 6918.412)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1499",
    "data-name": "Group 1499",
    transform: "translate(-9888.666 -6889.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1498",
    "data-name": "Group 1498",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 4.55,
    cy: 4.55,
    r: 4.55,
    transform: "translate(30.998 56.786)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 4.55,
    cy: 4.55,
    r: 4.55,
    transform: "translate(0 31.385)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 4.55,
    cy: 4.55,
    r: 4.55,
    transform: "translate(56.571 25.96)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 4.55,
    cy: 4.55,
    r: 4.55,
    transform: "translate(25.573 0.388)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5442",
    "data-name": "Path 5442",
    d: "M48.116,0A289.671,289.671,0,0,1,19.5,22.727l-.887.637c-1.8-1.5-3.617-3.026-5.369-4.55C8.69,14.9,4.209,10.874,0,6.575,6.484,10.647,12.626,15.2,18.7,19.861A288.36,288.36,0,0,1,48.116,0Z",
    transform: "translate(1.41 51.563) rotate(-90)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5443",
    "data-name": "Path 5443",
    d: "M48.116,0A289.671,289.671,0,0,1,19.5,22.727l-.887.637c-1.8-1.5-3.617-3.026-5.369-4.55C8.69,14.9,4.209,10.874,0,6.575,6.484,10.647,12.626,15.2,18.7,19.861A288.358,288.358,0,0,1,48.116,0Z",
    transform: "translate(64.087 14.594) rotate(90)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5444",
    "data-name": "Path 5444",
    d: "M48.116,0A289.671,289.671,0,0,1,19.5,22.727l-.887.637c-1.8-1.5-3.617-3.026-5.369-4.55C8.69,14.9,4.209,10.874,0,6.575,6.484,10.647,12.626,15.2,18.7,19.861A288.36,288.36,0,0,1,48.116,0Z",
    transform: "translate(51.302 64.348) rotate(180)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5445",
    "data-name": "Path 5445",
    d: "M396.116,231.4A289.67,289.67,0,0,1,367.5,254.127l-.887.637c-1.8-1.5-3.617-3.026-5.369-4.55-4.55-3.913-9.032-7.94-13.24-12.239,6.484,4.072,12.626,8.622,18.7,13.286A288.355,288.355,0,0,1,396.116,231.4Z",
    transform: "translate(-333.668 -229.762)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1496",
    "data-name": "Group 1496",
    transform: "translate(81.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5446",
    "data-name": "Path 5446",
    d: "M644.28,224.192h18.2a48.431,48.431,0,0,1,11.873,1.153,11.018,11.018,0,0,1,6.4,3.99q2.044,2.836,2.045,7.849V254.6q0,4.883-1.913,7.553a10.476,10.476,0,0,1-6.265,3.761A52.2,52.2,0,0,1,662.551,267H644.28V224.19Zm17.809,35.485a41.05,41.05,0,0,0,6.365-.364,5.253,5.253,0,0,0,3.1-1.417,4.805,4.805,0,0,0,.956-3.3V236.987a4.369,4.369,0,0,0-2.407-4.254q-2.409-1.218-7.685-1.219H654.57v28.164Z",
    transform: "translate(-644.28 -224.19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5447",
    "data-name": "Path 5447",
    d: "M850.13,224.2h10.29v35.488h21.042v7.321H850.13Z",
    transform: "translate(-803.299 -224.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5448",
    "data-name": "Path 5448",
    d: "M1017.71,255.267V224.2H1028v31.067q0,2.9,1.879,3.99t6.5,1.087c3.078,0,5.155-.362,6.365-1.087s1.813-2.054,1.813-3.99V224.2h10.29v31.067q0,12.4-18.6,12.4C1023.844,267.668,1017.71,263.535,1017.71,255.267Z",
    transform: "translate(-932.755 -224.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5449",
    "data-name": "Path 5449",
    d: "M1219.323,245.175,1204.218,224.2h11.873l9.168,14.248,9.1-14.248h11.874l-15.1,20.975,15.832,21.833h-11.939l-9.762-15.172-9.828,15.172H1203.56l15.763-21.833Z",
    transform: "translate(-1076.324 -224.198)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1497",
    "data-name": "Group 1497",
    transform: "translate(81.736 54.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5450",
    "data-name": "Path 5450",
    d: "M644.28,471.556V467.7q0-2.327,3.419-2.33a10.161,10.161,0,0,1,2.229.239v.9a9.144,9.144,0,0,0-2.2-.3,5.467,5.467,0,0,0-.851.057,3.239,3.239,0,0,0-.7.193,1.206,1.206,0,0,0-.726,1.226v3.806q0,1.4,2.329,1.4a9.16,9.16,0,0,0,2.2-.3v.926a10.4,10.4,0,0,1-2.28.239q-3.419,0-3.419-2.2Z",
    transform: "translate(-644.28 -464.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5451",
    "data-name": "Path 5451",
    d: "M678.84,474.627H679.9v.99a.785.785,0,0,1,.25-.546,1.84,1.84,0,0,1,.639-.414,2.026,2.026,0,0,1,.764-.157h.551v.965h-.626a2.411,2.411,0,0,0-1.158.207.784.784,0,0,0-.357.744v4.27h-1.126v-6.061Z",
    transform: "translate(-670.978 -471.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5452",
    "data-name": "Path 5452",
    d: "M700.253,480.657a1.132,1.132,0,0,1-.676-.576,2.744,2.744,0,0,1-.207-1.19,2.389,2.389,0,0,1,.193-1.069,1.116,1.116,0,0,1,.662-.546,4.232,4.232,0,0,1,1.333-.164h1.815v-.965a.864.864,0,0,0-.132-.519.738.738,0,0,0-.439-.257,4.021,4.021,0,0,0-.894-.075,16.046,16.046,0,0,0-2.079.15v-.826c.826-.075,1.574-.111,2.241-.111a5.6,5.6,0,0,1,1.552.157,1.07,1.07,0,0,1,.689.546,2.9,2.9,0,0,1,.189,1.2V480.7h-1.09v-.576c-.091.469-.7.7-1.827.7a4.223,4.223,0,0,1-1.333-.164Zm1.52-.576a5.193,5.193,0,0,0,1.04-.089c.375-.075.564-.25.564-.526v-1.654h-1.74a2.615,2.615,0,0,0-.776.082.468.468,0,0,0-.312.307,2.513,2.513,0,0,0-.075.726,2.138,2.138,0,0,0,.089.7.589.589,0,0,0,.312.35,1.657,1.657,0,0,0,.676.107h.225Z",
    transform: "translate(-686.837 -471.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5453",
    "data-name": "Path 5453",
    d: "M730.91,466.19h-1.39v-.739h1.39v-.976a1.693,1.693,0,0,1,.557-1.422,2.745,2.745,0,0,1,1.7-.432,9.979,9.979,0,0,1,1.015.061v.739a7.606,7.606,0,0,0-.976-.061,1.391,1.391,0,0,0-.894.225,1.019,1.019,0,0,0-.268.815v1.051h2.016v.739h-2.016v5.321h-1.126V466.19Z",
    transform: "translate(-710.128 -462.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5454",
    "data-name": "Path 5454",
    d: "M755.377,474.694a1.119,1.119,0,0,1-.632-.576,2.72,2.72,0,0,1-.193-1.147v-3.556H753.2v-.739h1.351V466.8h1.14v1.877h2.166v.739h-2.166v3.62a1.655,1.655,0,0,0,.107.676.609.609,0,0,0,.375.319,2.547,2.547,0,0,0,.783.093c.109,0,.41-.034.9-.1v.739a8.237,8.237,0,0,1-1.265.1A3.527,3.527,0,0,1,755.377,474.694Z",
    transform: "translate(-728.421 -465.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5455",
    "data-name": "Path 5455",
    d: "M781.81,465.43h1.126v1.176H781.81Zm0,2.191h1.126v6.061H781.81Z",
    transform: "translate(-750.522 -464.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5456",
    "data-name": "Path 5456",
    d: "M798.1,474.635h1.126v.739q.174-.863,1.991-.865a2.46,2.46,0,0,1,1.633.419,1.691,1.691,0,0,1,.469,1.322V480.7h-1.126v-4.382a1.655,1.655,0,0,0-.037-.389.848.848,0,0,0-.15-.3c-.166-.209-.539-.314-1.115-.314a4.325,4.325,0,0,0-1.021.093.834.834,0,0,0-.5.307,1.066,1.066,0,0,0-.143.6v4.382H798.1v-6.061Z",
    transform: "translate(-763.106 -471.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5457",
    "data-name": "Path 5457",
    d: "M831.818,483.312v-.8a21.478,21.478,0,0,0,2.191.175,2.236,2.236,0,0,0,1.258-.275,1.041,1.041,0,0,0,.394-.915v-1.451c-.018.266-.2.464-.546.589a3.893,3.893,0,0,1-1.308.187,4.78,4.78,0,0,1-1.458-.175,1.255,1.255,0,0,1-.739-.576,2.286,2.286,0,0,1-.219-1.09v-2.466a1.855,1.855,0,0,1,.582-1.54,3.086,3.086,0,0,1,1.909-.464q1.576,0,1.854.714v-.589h1.051v6.636a2.392,2.392,0,0,1-.312,1.315,1.67,1.67,0,0,1-.939.669,5.638,5.638,0,0,1-1.629.193,13.2,13.2,0,0,1-2.091-.139Zm3.481-3.456a.851.851,0,0,0,.364-.8v-2.741a1.19,1.19,0,0,0-.132-.626.778.778,0,0,0-.482-.307,4.3,4.3,0,0,0-1.026-.093,3.832,3.832,0,0,0-.958.089.677.677,0,0,0-.439.307,1.346,1.346,0,0,0-.118.632v2.741a1.285,1.285,0,0,0,.125.639.673.673,0,0,0,.45.294,4.254,4.254,0,0,0,.965.082,2.624,2.624,0,0,0,1.251-.214Z",
    transform: "translate(-788.823 -471.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5458",
    "data-name": "Path 5458",
    d: "M882.182,465.98H884l2.6,6.761.036.014,2.466-6.773h1.752v8.126h-1.065v-6.873h-.064l-2.616,6.873h-1.09l-2.691-6.873h-.062v6.873h-1.09v-8.126Z",
    transform: "translate(-828.058 -465.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5459",
    "data-name": "Path 5459",
    d: "M931.343,480.657a1.131,1.131,0,0,1-.676-.576,2.742,2.742,0,0,1-.207-1.19,2.387,2.387,0,0,1,.193-1.069,1.117,1.117,0,0,1,.662-.546,4.231,4.231,0,0,1,1.333-.164h1.816v-.965a.866.866,0,0,0-.132-.519.739.739,0,0,0-.439-.257A4.02,4.02,0,0,0,933,475.3a16.047,16.047,0,0,0-2.079.15v-.826c.826-.075,1.574-.111,2.241-.111a5.6,5.6,0,0,1,1.552.157,1.07,1.07,0,0,1,.689.546,2.9,2.9,0,0,1,.189,1.2V480.7H934.5v-.576c-.091.469-.7.7-1.827.7a4.225,4.225,0,0,1-1.333-.164Zm1.52-.576a5.19,5.19,0,0,0,1.04-.089c.375-.075.564-.25.564-.526v-1.654h-1.74a2.615,2.615,0,0,0-.776.082.468.468,0,0,0-.312.307,2.507,2.507,0,0,0-.075.726,2.134,2.134,0,0,0,.089.7.588.588,0,0,0,.312.35,1.659,1.659,0,0,0,.676.107h.225Z",
    transform: "translate(-865.354 -471.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5460",
    "data-name": "Path 5460",
    d: "M964.36,474.627h1.065v.99a.784.784,0,0,1,.25-.546,1.838,1.838,0,0,1,.639-.414,2.025,2.025,0,0,1,.764-.157h.55v.965H967a2.411,2.411,0,0,0-1.158.207.784.784,0,0,0-.357.744v4.27h-1.126v-6.061Z",
    transform: "translate(-891.542 -471.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5461",
    "data-name": "Path 5461",
    d: "M984.867,474.694a1.119,1.119,0,0,1-.633-.576,2.72,2.72,0,0,1-.193-1.147v-3.556H982.69v-.739h1.351V466.8h1.14v1.877h2.166v.739h-2.166v3.62a1.655,1.655,0,0,0,.107.676.609.609,0,0,0,.375.319,2.547,2.547,0,0,0,.783.093c.109,0,.409-.034.9-.1v.739a8.237,8.237,0,0,1-1.265.1A3.525,3.525,0,0,1,984.867,474.694Z",
    transform: "translate(-905.702 -465.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5462",
    "data-name": "Path 5462",
    d: "M1010.3,478.967v-2.391a1.866,1.866,0,0,1,.632-1.583,3.415,3.415,0,0,1,2.048-.482,3.165,3.165,0,0,1,1.934.464,1.918,1.918,0,0,1,.594,1.6v1.34h-4.07v.915a.977.977,0,0,0,.439.9,2.6,2.6,0,0,0,1.352.275,8.432,8.432,0,0,0,2.041-.3v.864a10.371,10.371,0,0,1-2.191.25q-2.781,0-2.78-1.854Zm4.081-1.79v-.951a.822.822,0,0,0-.332-.758,3.185,3.185,0,0,0-2.259,0,.8.8,0,0,0-.35.758v.951Z",
    transform: "translate(-927.031 -471.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5463",
    "data-name": "Path 5463",
    d: "M1044.269,480.8a3.928,3.928,0,0,1-.644-.125,1.331,1.331,0,0,1-.6-.3,1.625,1.625,0,0,1-.364-.589,2.558,2.558,0,0,1-.15-.94v-2.227a2.194,2.194,0,0,1,.387-1.454,1.816,1.816,0,0,1,.432-.382,1.517,1.517,0,0,1,.571-.182c.234-.034.441-.057.626-.068s.441-.018.776-.018a8.1,8.1,0,0,1,1.727.187v.826a7.756,7.756,0,0,0-1.866-.25,3.6,3.6,0,0,0-.957.093.658.658,0,0,0-.426.339,1.777,1.777,0,0,0-.118.744v2.48a1.4,1.4,0,0,0,.131.689.742.742,0,0,0,.476.318,4.23,4.23,0,0,0,1.022.093,7.181,7.181,0,0,0,1.827-.239v.851a9.755,9.755,0,0,1-1.941.175c-.418,0-.719-.009-.907-.025Z",
    transform: "translate(-951.913 -471.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5464",
    "data-name": "Path 5464",
    d: "M1071.773,463.17h1.126v3.442q.174-.863,1.991-.865a2.46,2.46,0,0,1,1.633.419,1.691,1.691,0,0,1,.469,1.322v4.445h-1.126v-4.37a1.652,1.652,0,0,0-.036-.389.847.847,0,0,0-.15-.3c-.166-.209-.539-.312-1.115-.312a4.467,4.467,0,0,0-1.046.093.783.783,0,0,0-.489.307,1.141,1.141,0,0,0-.132.6v4.37h-1.126V463.17Z",
    transform: "translate(-974.517 -463.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5465",
    "data-name": "Path 5465",
    d: "M1121.81,465.972h5.46v.851h-4.245v2.655h3.831v.851h-3.831v2.916h4.37v.851h-5.585V465.97Z",
    transform: "translate(-1013.172 -465.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5466",
    "data-name": "Path 5466",
    d: "M1154.665,478l-2.13-2.941h1.24l1.5,2.216,1.515-2.216h1.24L1155.9,478l2.254,3.117h-1.24l-1.64-2.391-1.627,2.391h-1.24Z",
    transform: "translate(-1036.811 -472.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5467",
    "data-name": "Path 5467",
    d: "M1186.039,480.8a3.926,3.926,0,0,1-.644-.125,1.328,1.328,0,0,1-.6-.3,1.628,1.628,0,0,1-.364-.589,2.557,2.557,0,0,1-.15-.94v-2.227a2.194,2.194,0,0,1,.387-1.454,1.828,1.828,0,0,1,.432-.382,1.522,1.522,0,0,1,.571-.182c.234-.034.441-.057.625-.068s.441-.018.776-.018a8.1,8.1,0,0,1,1.727.187v.826a7.756,7.756,0,0,0-1.866-.25,3.6,3.6,0,0,0-.957.093.659.659,0,0,0-.426.339,1.784,1.784,0,0,0-.118.744v2.48a1.4,1.4,0,0,0,.132.689.74.74,0,0,0,.475.318,4.229,4.229,0,0,0,1.021.093,7.181,7.181,0,0,0,1.827-.239v.851a9.752,9.752,0,0,1-1.941.175c-.419,0-.719-.009-.908-.025Z",
    transform: "translate(-1061.431 -471.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5468",
    "data-name": "Path 5468",
    d: "M1212.552,478.967v-2.391a1.865,1.865,0,0,1,.632-1.583,3.416,3.416,0,0,1,2.048-.482,3.165,3.165,0,0,1,1.934.464,1.919,1.919,0,0,1,.594,1.6v1.34h-4.07v.915a.977.977,0,0,0,.439.9,2.6,2.6,0,0,0,1.351.275,8.432,8.432,0,0,0,2.041-.3v.864a10.373,10.373,0,0,1-2.191.25q-2.781,0-2.78-1.854Zm4.081-1.79v-.951a.823.823,0,0,0-.332-.758,3.186,3.186,0,0,0-2.259,0,.8.8,0,0,0-.35.758v.951Z",
    transform: "translate(-1083.269 -471.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5469",
    "data-name": "Path 5469",
    d: "M1245.75,463.17h1.126v8.763h-1.126Z",
    transform: "translate(-1108.916 -463.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5470",
    "data-name": "Path 5470",
    d: "M1262.04,463.17h1.126v8.763h-1.126Z",
    transform: "translate(-1121.5 -463.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5471",
    "data-name": "Path 5471",
    d: "M1277.332,478.967v-2.391a1.866,1.866,0,0,1,.632-1.583,3.416,3.416,0,0,1,2.048-.482,3.165,3.165,0,0,1,1.934.464,1.919,1.919,0,0,1,.594,1.6v1.34h-4.07v.915a.977.977,0,0,0,.439.9,2.6,2.6,0,0,0,1.352.275,8.433,8.433,0,0,0,2.041-.3v.864a10.373,10.373,0,0,1-2.191.25q-2.781,0-2.78-1.854Zm4.082-1.79v-.951a.822.822,0,0,0-.332-.758,3.186,3.186,0,0,0-2.259,0,.8.8,0,0,0-.35.758v.951Z",
    transform: "translate(-1133.311 -471.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5472",
    "data-name": "Path 5472",
    d: "M1310.521,474.635h1.126v.739q.174-.863,1.99-.865a2.46,2.46,0,0,1,1.633.419,1.69,1.69,0,0,1,.469,1.322V480.7h-1.126v-4.382a1.661,1.661,0,0,0-.036-.389.848.848,0,0,0-.15-.3,1.428,1.428,0,0,0-1.115-.314,4.326,4.326,0,0,0-1.021.093.835.835,0,0,0-.5.307,1.068,1.068,0,0,0-.143.6v4.382h-1.126v-6.061Z",
    transform: "translate(-1158.952 -471.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5473",
    "data-name": "Path 5473",
    d: "M1345.579,480.8a3.919,3.919,0,0,1-.644-.125,1.329,1.329,0,0,1-.6-.3,1.623,1.623,0,0,1-.364-.589,2.555,2.555,0,0,1-.15-.94v-2.227a2.193,2.193,0,0,1,.386-1.454,1.823,1.823,0,0,1,.432-.382,1.519,1.519,0,0,1,.571-.182c.234-.034.441-.057.626-.068s.441-.018.776-.018a8.1,8.1,0,0,1,1.727.187v.826a7.755,7.755,0,0,0-1.866-.25,3.607,3.607,0,0,0-.958.093.658.658,0,0,0-.425.339,1.776,1.776,0,0,0-.119.744v2.48a1.4,1.4,0,0,0,.132.689.742.742,0,0,0,.476.318,4.227,4.227,0,0,0,1.021.093,7.181,7.181,0,0,0,1.827-.239v.851a9.754,9.754,0,0,1-1.941.175c-.418,0-.719-.009-.907-.025Z",
    transform: "translate(-1184.676 -471.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5474",
    "data-name": "Path 5474",
    d: "M1372.1,478.967v-2.391a1.867,1.867,0,0,1,.632-1.583,3.417,3.417,0,0,1,2.048-.482,3.165,3.165,0,0,1,1.934.464,1.919,1.919,0,0,1,.594,1.6v1.34h-4.07v.915a.977.977,0,0,0,.439.9,2.6,2.6,0,0,0,1.351.275,8.433,8.433,0,0,0,2.041-.3v.864a10.374,10.374,0,0,1-2.191.25q-2.781,0-2.78-1.854Zm4.082-1.79v-.951a.822.822,0,0,0-.332-.758,3.186,3.186,0,0,0-2.259,0,.8.8,0,0,0-.35.758v.951Z",
    transform: "translate(-1206.522 -471.805)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskGroup284);
export default __webpack_public_path__ + "static/media/Mask Group 284.7a604b68736a162e1d79a22b601dee04.svg";
export { ForwardRef as ReactComponent };